import crypto from 'crypto-js';
import {jwtDecode} from 'jwt-decode'; // Correct import for jwt-decode

export const encryptData = (data, key) => {
  return crypto.AES.encrypt(data, key).toString();
};

export const decryptData = (encryptedData, key) => {
  try {
    if (!encryptedData || typeof encryptedData !== 'string' || !encryptedData.startsWith('U2FsdGVkX1')) {
      // Return the original data if it's not encrypted
      return encryptedData;
    }

    const bytes = crypto.AES.decrypt(encryptedData, key);
    const decryptedData = bytes.toString(crypto.enc.Utf8);

    return decryptedData || encryptedData; // Return original data if decryption fails
  } catch (error) {
    console.error('Failed to decrypt data:', error, { encryptedData });
    return encryptedData; // Return original data on error
  }
}